import { render, staticRenderFns } from "./AppFeather.vue?vue&type=template&id=25b29b62"
import script from "./AppFeather.vue?vue&type=script&lang=js"
export * from "./AppFeather.vue?vue&type=script&lang=js"
import style0 from "./AppFeather.vue?vue&type=style&index=0&id=25b29b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports